import { t } from 'ttag';
import { useState } from 'react';
import classNames from 'classnames';

import { IndexSuggestionItemsBlockPreloaderContainer } from '@containers/IndexSuggestionItemsBlockPreloaderContainer';
import { ConversionsCollectionContainer } from '@containers/ConversionsCollectionContainer';
import { LayoutContainer } from '@ui/LayoutContainer';
import {
  ConversionTopSellerProductsContainer,
} from '@containers/ConversionTopSellerProducts';
import { dayDiscount, newArrivals } from '@urls';
import { novelties } from '@constants';

import s from './ConversionsProducts.sss';

enum СonversionsProducts {
  CONVERSIONS_FEATURED = 'featured',
  CONVERSIONS_NEW_ARRIVALS = 'new-arrivals',
  CONVERSIONS_DAY_DISCOUNT = 'day-discount',
  CONVERSIONS_TOP_SELLER_PRODUCTS = 'top-seller-products',
}

type ConversionsProductsProps = {
  className?: string;
};

export const ConversionsProducts: React.FC<ConversionsProductsProps> = () => {
  const [activeTab, isActiveTab] = useState(СonversionsProducts.CONVERSIONS_FEATURED);

  const content = () => {
    switch (activeTab) {
      case СonversionsProducts.CONVERSIONS_FEATURED:
        return <IndexSuggestionItemsBlockPreloaderContainer />;
      case СonversionsProducts.CONVERSIONS_NEW_ARRIVALS:
        return <ConversionsCollectionContainer slug={novelties} href={newArrivals} />;
      case СonversionsProducts.CONVERSIONS_DAY_DISCOUNT:
        return <ConversionsCollectionContainer slug="skidka-dnya" href={dayDiscount} />;
      case СonversionsProducts.CONVERSIONS_TOP_SELLER_PRODUCTS:
        return <ConversionTopSellerProductsContainer />;
      default:
        return null;
    }
  };

  return (
    (
      <LayoutContainer className={s.root}>
        <div className={s.tabRoot}>
          <div className={s.tabBar}>
            <div
              className={
              classNames(
                s.tabLink,
                { [s.active]: activeTab === СonversionsProducts.CONVERSIONS_FEATURED },
              )
            }
              onClick={() => {
                isActiveTab(СonversionsProducts.CONVERSIONS_FEATURED);
              }}
            >
              {t`Рекомендовані`}
            </div>
            <div
              className={
              classNames(
                s.tabLink,
                { [s.active]: activeTab === СonversionsProducts.CONVERSIONS_NEW_ARRIVALS },
              )
            }
              onClick={() => {
                isActiveTab(СonversionsProducts.CONVERSIONS_NEW_ARRIVALS);
              }}
            >
              {t`Новинки`}
            </div>
            <div
              className={
              classNames(
                s.tabLink,
                { [s.active]: activeTab === СonversionsProducts.CONVERSIONS_DAY_DISCOUNT },
              )
            }
              onClick={() => {
                isActiveTab(СonversionsProducts.CONVERSIONS_DAY_DISCOUNT);
              }}
            >
              {t`Знижки`}
            </div>
            <div
              className={
              classNames(
                s.tabLink,
                { [s.active]: activeTab === СonversionsProducts.CONVERSIONS_TOP_SELLER_PRODUCTS },
              )
            }
              onClick={() => {
                isActiveTab(СonversionsProducts.CONVERSIONS_TOP_SELLER_PRODUCTS);
              }}
            >
              {t`Топ-продавці`}
            </div>
          </div>
        </div>
        {
        content()
      }
      </LayoutContainer>
    )
  );
};
